import React, { useState } from 'react';
import axiosInstance from '../api/axiosInstance'; // Use configured axios instance
import bg from '../images/bg1.jpg';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { styled } from "@mui/material/styles";
import ButtonBox from './UI/ButtonBox';
import Para from './UI/Para';
import { useNavigate } from 'react-router-dom';

const CustomTextField = styled(TextField)({
  "& div.MuiFormControl-root": {
    width: '100% !important',
  },
  "& label.Mui-focused": {
    color: "black",
  },
  "& .MuiInput-underline": {
    width: '100%',
    "& fieldset": {
      borderColor: "gray",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
    "& input": {
      color: "black",
    },
  },
});

const Login = ({ setIsLoggedIn, setUserName, setUserLocation, setUserRole }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        const response = await axiosInstance.post('/login', { email, password });
        setMessage(response.data.message);
        if (response.data.message === 'Login successful') {
          // Set localStorage values
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('userName', response.data.userName);
          localStorage.setItem('userLocation', response.data.userLocation);
          localStorage.setItem('userRole', response.data.userRole || 'user');
          localStorage.setItem('token', response.data.token); // Store JWT token
          
          setIsLoggedIn(true);
          setUserName(response.data.userName);
          setUserLocation(response.data.userLocation);
          if (setUserRole) {
            setUserRole(response.data.userRole || 'user');
          }
          navigate('/');
        }
    } catch (error) {
        console.error('Login Error:', error);
        if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
            setMessage('Network error: Please check your internet connection and try again.');
        } else if (error.response) {
            setMessage(error.response.data?.message || `Server error: ${error.response.status}`);
        } else {
            setMessage('Connection failed: Unable to reach server. Please try again later.');
        }
    }
  };

  return (
    <div className='loginWrap'>
      <img src='/logo152.png' alt='logo' className='logo' />
      <Para variant='h2' color='secondary' text='Welcome' sx={{ my: 2 }} />
      <form onSubmit={handleSubmit} className='formLogin'>
        <div>
          <CustomTextField id="standard-basic" label="Email/Phone Number" variant="standard" value={email}
            onChange={(e) => setEmail(e.target.value)}
            required type='text' />
        </div>
        <div>
          <CustomTextField
            type="password"
            variant='standard'
            label='Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <ButtonBox type='submit' placeholder='Login' variant='contained' />
      </form>
      <div style={{ marginTop: '1rem' }}>
        <p>
          Not registered yet?{' '}
          <a href="/register" style={{ color: 'blue', textDecoration: 'underline' }}>
            Register here
          </a>
        </p>
      </div>
      {message && <p>{message}</p>}
    </div>
  );
};

export default Login;